import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FiMail, FiArrowLeft, FiCheckCircle } from 'react-icons/fi';
import { useLanguage } from '../../context/LanguageContext';
import { toast } from 'react-toastify';
import authService from '../../services/auth.service';

const ForgotPasswordPage = () => {
  const { t } = useLanguage();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email.trim()) {
      toast.error('Please enter your email');
      return;
    }
    setLoading(true);
    try {
      await authService.forgotPassword(email);
      setSent(true);
    } catch (error) {
      toast.error(error.response?.data?.message || 'Failed to send reset email');
    } finally {
      setLoading(false);
    }
  };

  if (sent) {
    return (
      <div className="section-padding d-flex align-items-center justify-content-center" style={{ minHeight: '70vh' }}>
        <div className="text-center" style={{ maxWidth: '420px' }}>
          <FiCheckCircle size={56} className="text-success mb-3" />
          <h3>Check Your Email</h3>
          <p className="text-muted">
            We've sent a password reset link to <strong>{email}</strong>.
            The link expires in 30 minutes.
          </p>
          <p className="text-muted small">
            Didn't receive the email? Check your spam folder or{' '}
            <button className="btn btn-link p-0" onClick={() => setSent(false)}>try again</button>.
          </p>
          <Link to="/login" className="btn btn-ebw-outline mt-3">
            <FiArrowLeft className="me-1" /> Back to Login
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="section-padding d-flex align-items-center justify-content-center" style={{ minHeight: '70vh' }}>
      <div className="auth-page" style={{ maxWidth: '420px', width: '100%' }}>
        <div className="dashboard-card">
          <h3 className="mb-2">{t('forgotPasswordTitle')}</h3>
          <p className="text-muted mb-4">
            Enter your email and we'll send you a link to reset your password.
          </p>

          <form onSubmit={handleSubmit}>
            <div className="mb-3">
              <label className="form-label">Email Address</label>
              <div className="input-group">
                <span className="input-group-text"><FiMail /></span>
                <input
                  type="email"
                  className="form-control"
                  placeholder="you@example.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>
            </div>

            <button type="submit" className="btn btn-ebw-primary w-100 btn-lg" disabled={loading}>
              {loading ? 'Sending...' : t('sendResetLink')}
            </button>
          </form>

          <div className="text-center mt-3">
            <Link to="/login" className="text-muted text-decoration-none">
              <FiArrowLeft className="me-1" /> Back to Login
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPasswordPage;
